module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="zmags-section wide">\n    <div class="image-library-region"></div>\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/imageLibrary/AbstractImageLibraryView.tpl
// module id = 2852
// module chunks = 0